/* =============================================================================
   PBF Blog — Artikel: leesvoortgangsbalk bovenaan de pagina.
   ============================================================================= */

(function () {
  var bar = document.getElementById('pbf-article-progress');
  if (!bar) return;

  function update() {
    var el = document.scrollingElement || document.documentElement;
    var max = el.scrollHeight - el.clientHeight;
    var pct = max > 0 ? Math.min(100, Math.max(0, (el.scrollTop / max) * 100)) : 0;
    bar.style.width = pct + '%';
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();

/* =============================================================================
   Artikel-inhoud opmaken
   De tekst komt als rich text uit de Shopify-blogeditor; daar kun je geen
   klassen of wrappers meegeven. Deze drie ingrepen doen dat alsnog, zodat de
   opmaak klopt zonder dat de redactie iets extra's hoeft te doen.
   ============================================================================= */
(function () {
  var rte = document.querySelector('.pbf-article__rte');
  if (!rte) return;

  /* 1. Lege alinea's (vaak een achtergebleven &nbsp;) weghalen — die laten
        anders een gat vallen tussen twee blokken. */
  Array.prototype.forEach.call(rte.querySelectorAll('p'), function (p) {
    if (p.children.length === 0 && p.textContent.trim() === '') {
      p.remove();
    }
  });

  /* 2. Tabellen in een scroll-wrapper zetten, zodat een brede
        vergelijkingstabel op mobiel schuift in plaats van dichtgeknepen wordt. */
  Array.prototype.forEach.call(rte.querySelectorAll('table'), function (table) {
    if (table.parentElement && table.parentElement.classList.contains('pbf-article__table-wrap')) return;
    var wrap = document.createElement('div');
    wrap.className = 'pbf-article__table-wrap';
    wrap.setAttribute('role', 'region');
    wrap.setAttribute('tabindex', '0');
    wrap.setAttribute('aria-label', 'Tabel, horizontaal scrollbaar');
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });

  /* 3. Een alinea die uit niets anders bestaat dan één link is een
        call-to-action — die wordt een merkknop. */
  Array.prototype.forEach.call(rte.querySelectorAll('p'), function (p) {
    var links = p.querySelectorAll('a');
    if (links.length !== 1) return;
    var linkText = links[0].textContent.trim();
    var pText = p.textContent.trim();
    if (linkText.length > 0 && linkText === pText) {
      p.classList.add('pbf-article__rte-cta');
    }
  });
})();

/* Deel-balk: "link kopiëren"-knop */
(function () {
  var btns = document.querySelectorAll('.pbf-article__share-copy');
  if (!btns.length) return;

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  Array.prototype.forEach.call(btns, function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-url') || window.location.href;

      function done() {
        btn.classList.add('is-copied');
        btn.setAttribute('aria-label', 'Link gekopieerd');
        setTimeout(function () {
          btn.classList.remove('is-copied');
          btn.setAttribute('aria-label', 'Link kopiëren');
        }, 1800);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { fallbackCopy(url); done(); });
      } else {
        fallbackCopy(url);
        done();
      }
    });
  });
})();
